import EditIcon from "@mui/icons-material/Edit";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import LoopIcon from "@mui/icons-material/Loop";
import { Box, IconButton, Tooltip } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { useMemo } from "react";
import { tableConfig } from "../../commons/table/tableConfig";

const NominaCompletaTable = ({ data, loading, onEdit, onExport, onRefresh }) => {
  const columns = useMemo(() => [
    {
      accessorKey: "cuil",
      header: "CUIL",
      size: 130,
      minSize: 130,
      maxSize: 150,
      muiTableBodyCellProps: {
        sx: {
          whiteSpace: "nowrap",
        },
      },
    },
    { accessorKey: "nombre", header: "Nombre", size: 200 },
    { accessorKey: "tipoDocumento", header: "Tipo DNI", size: 100 },
    { accessorKey: "numeroDocumento", header: "DNI", size: 130 },
    { accessorKey: "direccion", header: "Dirección", size: 250 },
    { accessorKey: "telefono", header: "Teléfono", size: 130 },
    { accessorKey: "celular", header: "Celular", size: 130 },
    {
      accessorKey: "fechaIngreso",
      header: "Fecha de Ingreso",
      size: 150,
      Cell: ({ cell }) => {
        const val = cell.getValue();
        return val ? new Date(val).toLocaleDateString('es-AR') : "";
      }
    },
    {
      accessorKey: "fechaBaja",
      header: "Fecha de Baja",
      size: 150,
      Cell: ({ cell }) => {
        const val = cell.getValue();
        return val ? new Date(val).toLocaleDateString('es-AR') : "";
      }
    },
    { accessorKey: "domestica", header: "Doméstica", size: 100 },
    { accessorKey: "establecimiento", header: "Establ.", size: 200 },
    { accessorKey: "codigoEstablecimientoSrt", header: "Cod. Establ. SRT", size: 180 },
    { accessorKey: "matrizUnica", header: "Matriz Única", size: 150 },
    { accessorKey: "domicilioEstablecimiento", header: "Domicilio\nEstabl.", size: 250 },
  ], []);

  const table = useMaterialReactTable({
    ...tableConfig,
    columns,
    enableColumnActions: false,
    data: data || [],
    state: {
      isLoading: loading,
    },
    enableRowActions: true,
    positionActionsColumn: "last",
    renderRowActions: ({ row }) => (
      <Tooltip title="Editar">
        <IconButton onClick={() => onEdit(row.original.cuil)} color="primary">
          <EditIcon />
        </IconButton>
      </Tooltip>
    ),
    renderTopToolbarCustomActions: () => (
      <Box sx={{ display: "flex", gap: "0.5rem" }}>
        <Tooltip title="Recargar">
          <IconButton onClick={onRefresh}>
            <LoopIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Exportar a CSV">
          <IconButton onClick={onExport}>
            <FileDownloadIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    getRowId: (row) => row.idNomina || row.cuil || Math.random().toString(),
  });

  return (
    <Box sx={{ height: 600, width: "100%", mt: 2 }}>
      <MaterialReactTable table={table} />
    </Box>
  );
};

export default NominaCompletaTable;
